import { getAvailableContractRoles } from "@features/administration/users/UserForm/const"
import { MenuItem, Select, SelectProps } from "@mui/material"
import { GridRowId, useGridApiContext } from "@mui/x-data-grid"
import { useLayoutEffect, useRef } from "react"

type SelectContractRolesProps = SelectProps & {
  value: string
  hasFocus?: boolean
  field: string
  gridRowId: GridRowId
}

const SelectContractRoles = ({
  value,
  hasFocus,
  field,
  gridRowId,
  ...props
}: SelectContractRolesProps) => {
  const ref = useRef<HTMLInputElement>()
  const apiRef = useGridApiContext()
  const roleOptions = getAvailableContractRoles(apiRef.current, gridRowId)

  useLayoutEffect(() => {
    if (hasFocus) ref?.current?.focus()
  }, [hasFocus])

  return (
    <Select
      fullWidth
      value={value}
      ref={ref}
      onChange={({ target: { value } }) => {
        apiRef.current.setEditCellValue({ id: gridRowId, field, value })
      }}
      {...props}
    >
      {roleOptions.map(({ label, value, isUsed }) => (
        <MenuItem key={value} value={value} disabled={isUsed}>
          {label}
        </MenuItem>
      ))}
    </Select>
  )
}

export default SelectContractRoles
